import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { arrayBufferToBase64 } from 'web/src/utils/bufferToBase64'
import * as actions from '../actions'
import { useStyles } from './images-section-styles'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import { useBooleanState } from 'web/src/utils/hooks/useBooleanState'

export const ImagesComponent = ({ commentId }) => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const { commentsPictures, imagesLoader } = useSelector(
        state => state.reports
    )

    const [imageForModal, setImageForModal] = useState('')

    useEffect(() => {
        if (!imagesLoader) {
            dispatch(actions.getImagesFromCommentById(commentId))
        }
    }, [commentId])

    const lightbox = useBooleanState(false)

    return (
        <div className={classes.imagesComponentContainer}>
            {commentsPictures[commentId]?.map((item, index) => {
                return (
                    <div key={index} className={classes.imageContainer}>
                        {lightbox.is && (
                            <Lightbox
                                animationDuration={200}
                                reactModalStyle={{
                                    overlay: { zIndex: 3000 }
                                }}
                                mainSrc={imageForModal}
                                onCloseRequest={lightbox.off}
                            />
                        )}
                        <div className={classes.imageWrapper}>
                            <img
                                onClick={() => {
                                    lightbox.on()
                                    setImageForModal(
                                        `data:image/jpeg;base64,${arrayBufferToBase64(
                                            item.Body.data
                                        )}`
                                    )
                                }}
                                className={classes.imageStyles}
                                src={`data:image/jpeg;base64,${arrayBufferToBase64(
                                    item.Body.data
                                )}`}
                            />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
